
import { Link } from "react-router-dom";
import { StyledHomeNav } from "../../layout/userNav/Nav.styled";
import { homeNavLink } from "../../utils/data";
import { ICON_LIST, ICON_LOGOUT } from "../../utils/icons";
import { logo_main } from "../../assets";
import { Button } from "../../styles";
import { useUserContext } from "../../context/user_context";

const HomeNavbar = () => {

      const { usertoken, btoken, stoken } = useUserContext();


      return (
            <StyledHomeNav
            >
                  <nav className="navbar fixed-top navbar-expand-lg sec " id="navbar">
                        <div className="container">
                              <Link to="/" className=" pry-text">
                                    <img src={logo_main} width="90px" alt="logo" loading="lazy" />

                              </Link>

                              <a
                                    className="navbar-toggler"
                                    type="button"
                                    data-mdb-toggle="collapse"
                                    data-mdb-target="#navbarSupportedContent"
                                    aria-controls="navbarSupportedContent"
                                    aria-expanded="false"
                                    aria-label="Toggle navigation"
                              >
                                    <span className="navbar-toggler-icon toggler h3 pry-text">
                                          {ICON_LIST}
                                    </span>
                              </a>

                              <div className="collapse navbar-collapse " id="navbarSupportedContent">
                                    <ul className="navbar-nav text-center ">
                                          {homeNavLink.map(({ title, to }, i) => {
                                                return (
                                                      <li className="nav-item" key={i}>
                                                            <Link className="active" to={to}>
                                                                  {title}
                                                            </Link>
                                                      </li>
                                                );
                                          })}
                                    </ul>
                                    <ul className=" navbar-nav gap-2 text-center  ms-auto ">
                                          {!usertoken ? (
                                                <>
                                                      <li className=" mb-1">
                                                            <Link to="/register">
                                                                  <Button className="btn light-bg pry-text register-btn">
                                                                        Get Started For Free
                                                                  </Button>
                                                            </Link>
                                                      </li>
                                                      <li className=" mb-1">
                                                            <Link to="/login">
                                                                  <Button className="btn yellow-bg light-text login-btn">
                                                                        Sign In
                                                                  </Button>
                                                            </Link>
                                                      </li>
                                                </>
                                          ) : (
                                                <>
                                                      {btoken && stoken ?
                                                            <li className=" mb-1">
                                                                  <Link to="/user/dashboard">
                                                                        <Button pry className="btn">
                                                                              Dashboard
                                                                        </Button>
                                                                  </Link>
                                                            </li> : <></>
                                                      }
                                                      <li className=" mb-1">
                                                            <Button
                                                                  // onClick={HandleLogout} 
                                                                  className="btn register-btn">
                                                                  {ICON_LOGOUT}                                                                  Logout
                                                            </Button>
                                                      </li>
                                                </>
                                          )}
                                    </ul>
                              </div>
                        </div>
                  </nav>
            </StyledHomeNav>

      );
};

export default HomeNavbar;


